"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var ScrollDiv_1 = __importDefault(require("components/Layout/ScrollDiv"));
var LogoSection_1 = __importDefault(require("../LogoSection"));
var Footer_1 = require("./styles/Footer");
var InviteTemplate = function (_a) {
    var onClick = _a.onClick, onBeforeClick = _a.onBeforeClick, isNextDisabled = _a.isNextDisabled, onPrevClick = _a.onPrevClick, children = _a.children;
    var _b = __read((0, react_1.useState)(false), 2), sending = _b[0], setSending = _b[1];
    var onClickNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSending(true);
                    if (!onBeforeClick) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onBeforeClick()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    setSending(false);
                    return [3 /*break*/, 4];
                case 4:
                    onClick === null || onClick === void 0 ? void 0 : onClick();
                    setSending(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", height: "100%" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ flexShrink: 1 }, { children: (0, jsx_runtime_1.jsx)(LogoSection_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ flexGrow: 2 }, { children: (0, jsx_runtime_1.jsx)(ScrollDiv_1.default, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ height: "100%", display: "flex", justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", flexDirection: "column", justifyContent: "center", maxWidth: 470, width: "100%", py: 4 }, { children: children })) })) }) })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ flexShrink: 1 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { borderTop: 1, borderColor: "text.secondary" }), (0, jsx_runtime_1.jsxs)(Footer_1.Footer, { children: [(0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", onClick: onPrevClick }, { children: "Go back" })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "green", size: "large", isSending: sending, type: "submit", disabled: isNextDisabled || sending, onClick: onClickNext }, { children: sending ? 'Sending' : 'Send Invites' }))] })] }))] })));
};
exports.default = InviteTemplate;
